import { render, staticRenderFns } from "./MioSchoolsMap.vue?vue&type=template&id=028b6852&"
import script from "./MioSchoolsMap.vue?vue&type=script&lang=js&"
export * from "./MioSchoolsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports